import { useContext } from 'react';

import { SupportContext } from "../../../hoc/SupportContext"
import { getDomains } from '../../../components/utils/utils';
import {Listbox, ListboxButton,ListboxOption, ListboxOptions } from '@headlessui/react'
import {  CheckIcon, ChevronUpDownIcon} from '@heroicons/react/24/outline'

const ProductList = () => {
        const { selectedProduct, handleSelectedProduct } = useContext(SupportContext)

    return ( 
            <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
                        <div className='flex justify-center mb-6'>
                    {selectedProduct &&
                  <Listbox value={selectedProduct} onChange={handleSelectedProduct}>
                          <div className="relative">
                            <ListboxButton className="relative w-40 lg:w-52 cursor-default rounded-full bg-white py-2.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 text-xs sm:text-sm">
                              <span className="flex items-center">
                                <img alt="" src={selectedProduct.avatar} className="h-5 w-5 shrink-0 rounded-full" />
                                <span className="ml-3 block truncate">{selectedProduct.name}</span>
                              </span>
                              <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                              </span>
                            </ListboxButton>
            
                            <ListboxOptions
                              transition
                              className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-2xl bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                            >
                              
                              {getDomains().map((person) => (
                                <ListboxOption
                                  key={person.id}
                                  value={person}
                                  className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-red-600 data-[focus]:text-white"
                                >
                                  <div className="flex items-center">
                                    <img alt="" src={person.avatar} className="h-5 w-5 shrink-0 rounded-full bg-white" />
                                    <span className="ml-3 block truncate text-xs sm:text-sm font-normal group-data-[selected]:font-semibold">
                                      {person.name}
                                    </span>
                                  </div>
            
                                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-red-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                    <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                  </span>
                                </ListboxOption>
                              ))}
                            </ListboxOptions>
                          </div>
                        </Listbox> }
                      </div>
                    </div>)
}

export default ProductList;